var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaybutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46067 1.01668C0.597334 1.48334 0 2.34668 0 3.57168V16.405C0 18.855 2.44067 20.0263 4.45667 18.883L13.9603 13.4883C17.1827 11.4933 17.0637 8.41334 13.9603 6.48835L4.45667 1.09135C4.00423 0.826687 3.49201 0.681217 2.968 0.668566C2.44399 0.655914 1.92535 0.776495 1.46067 1.01901V1.01668Z",
    fill: "#054BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybutton);
export default __webpack_public_path__ + "static/media/playbutton.b279952ca62862488708957bb26d5f4c.svg";
export { ForwardRef as ReactComponent };